import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from '../users.service';
import { LoginResponse } from '../login-response.interface';

/**
 * Landing page for a "Become User" link.
 *
 * It renders nothing — it swaps the browser session over to the target user and moves on. The
 * route sits outside both shells, so NoAuthGuard cannot bounce a browser that already holds a
 * currentUser, and AuthGuard cannot block one that does not.
 */
@Component({
    selector: 'app-become-user',
    template: '',
})
export class BecomeUserComponent {
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private usersService: UsersService,
	) {}

	ngOnInit() {
		const token = this.route.snapshot.params['token'];

		this.usersService.becomeUser({ params: token }).subscribe({
			next: (res: LoginResponse) => this.startSession(res),
			// the interceptor already shows the "link expired" message
			error: () => this.router.navigate(['/login']),
		});
	}

	// Same bootstrap as LoginComponent: store the session, then load the access functions
	// before landing on the dashboard.
	private startSession(res: LoginResponse) {
		const currentUser = {
			first_name: res.first_name,
			last_name: res.last_name,
			access_functions: null,
			accessToken: res.accessToken,
			refreshToken: res.refreshToken,
		};
		localStorage.setItem('currentUser', JSON.stringify(currentUser));

		this.usersService.getCurrentUserAccessFunctions().subscribe((accessFunctionsRes: {data: object}) => {
			currentUser.access_functions = accessFunctionsRes.data;
			localStorage.setItem('currentUser', JSON.stringify(currentUser));

			if (this.usersService.isDemoMode())
				return this.router.navigate(['search-device-details']);

			return this.router.navigate(['dashboard']);
		});
	}
}
